import React from "react";
import { Container, Row } from "react-bootstrap";
import BadgeCard from "./badgeCard";
import AppointmentCard from "./appointmentCard";
import "../home.scss";

export default function reminderCards({ userDetails, latestBadge, history }) {
	return (
		<Container className="reminder-cards-main-container">
			<Row className="mb-2">
				<AppointmentCard userDetails={userDetails} />
			</Row>
			<Row className="mt-2">
				<BadgeCard latestBadge={latestBadge} history={history} />
			</Row>
		</Container>
	);
}
